// extracted by mini-css-extract-plugin
module.exports = {"downloadBadges":"styles_downloadBadges__EeCx8","icon":"styles_icon__VyI5A","iconAndroid":"styles_iconAndroid__3jMby"};